module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp13_9016.c1117bcd.png";